var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeliveriesSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4167 0.5V6.5H21.1667V19.25C21.1667 20.4927 20.1593 21.5 18.9167 21.5H2.41669C1.17403 21.5 0.166687 20.4922 0.166687 19.25V6.5H9.91669V0.5H11.4167ZM10.2964 16.6297L14.7964 12.1297C15.2745 11.7313 15.2768 11.0209 14.8372 10.5814C14.3975 10.142 13.6857 10.142 13.2462 10.5814L9.54169 14.2859L8.08716 12.8295C7.64747 12.39 6.93567 12.3898 6.49622 12.8295C6.05677 13.2692 6.05677 13.981 6.49622 14.4204L8.74622 16.6704C8.96606 16.8901 9.25575 17 9.54169 17C9.82762 17 10.1182 16.8922 10.2964 16.6297Z",
    fill: "#E34B31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91669 0.5V6.5H0.225281C0.216492 6.48828 0.210632 6.48008 0.204773 6.47188C0.198914 6.46367 0.193054 6.45547 0.184265 6.44375L2.82684 1.52562C3.03216 0.910156 3.60028 0.5 4.25091 0.5H9.91669ZM18.5051 1.52656L21.1479 6.44375C21.1409 6.45547 21.135 6.46367 21.1292 6.47188C21.1233 6.48008 21.1175 6.48828 21.1104 6.5H11.4167V0.5H17.0839C17.7354 0.5 18.3026 0.910156 18.5051 1.52656Z",
    fill: "#E34B31"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveriesSelected);
export default __webpack_public_path__ + "static/media/deliveries-selected.ec8cdcc6d4afab7aae844a8735458312.svg";
export { ForwardRef as ReactComponent };